import * as React from "react";
import * as ReactDOM from "react-dom";
import $ from "jquery";
import "./app.scss";
import { BrowserRouter } from "react-router-dom";
import App from "../components/app";
import { Provider } from "react-redux";
import { store } from "../state/store";
import MobileApp from "../mobileComponents/app";
import { EnvProvider } from "../components/envContext";
import { setSubdomain } from "../state/features/subdomain";

// Translations
import LocaleWrapper from "../wrappers/localeWrapper";
import { PusherProvider } from "../components/pusherContext";
import PromotionsProvider from "../features/promotions/providers/promotionsProvider";

document.addEventListener("DOMContentLoaded", () => {
  let appRootElement = document.getElementById("root") as HTMLDivElement;
  if (appRootElement) {
    let pusherId = appRootElement?.dataset.pusherId;
    let subdomain = appRootElement?.dataset.subdomain || null;
    
    // Initialize subdomain in Redux store from HTML data attribute
    if (subdomain && subdomain !== 'undefined' && subdomain !== '') {
      store.dispatch(setSubdomain(subdomain));
    }

    ReactDOM.render(
      <EnvProvider envObject={appRootElement.dataset}>
        <PusherProvider pusherId={pusherId}>
          <Provider store={store}>
            <BrowserRouter>
              <LocaleWrapper>
                <PromotionsProvider>
                  {screen.width > 768 ? <App /> : <MobileApp />}
                </PromotionsProvider>
              </LocaleWrapper>
            </BrowserRouter>
          </Provider>
        </PusherProvider>
      </EnvProvider>,
      appRootElement
    );
  }
});
